import { featuredEvents } from "@/mocks/guaEvents";
import { hotRankList } from "@/mocks/guaHot";

const picks = featuredEvents.slice(1, 4);

export default function Hero() {
  const lead = featuredEvents[0];
  return (
    <section id="focus" className="w-full">
      <div className="mx-auto grid max-w-7xl gap-6 px-4 py-8 md:grid-cols-3 md:px-6 md:py-10">
        {/* 头条大卡 */}
        <div className="md:col-span-2">
          <a href="#news" className="block overflow-hidden rounded-xl border border-orange-900/10 bg-stone-900">
            <div className="relative h-[300px] w-full md:h-[400px]">
              <img
                src={lead.cover}
                alt={`${lead.title} · 全网热瓜最新进展`}
                title={`${lead.title} · 全网热瓜最新进展`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/5"></div>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-red-700 px-2.5 py-1 text-xs font-medium text-white">
                    <i className="ri-fire-fill"></i>
                    今日聚焦
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-white/90 px-2.5 py-1 text-xs font-medium text-stone-800">
                    {lead.tag}
                  </span>
                  <span className="rounded-full bg-amber-500/90 px-2.5 py-1 text-xs font-medium text-amber-950">
                    {lead.status}
                  </span>
                </div>
                <h2 className="font-masthead mt-3 text-xl font-bold leading-snug text-white md:text-[26px]">
                  {lead.title}
                </h2>
                <p className="mt-2 hidden max-w-2xl text-sm leading-relaxed text-white/80 md:block">
                  {lead.excerpt}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-white/70">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {lead.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {lead.read}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-arrow-right-up-line"></i>
                    点击进入完整时间线
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* 右侧：实时热议 + 编辑精选 */}
        <aside className="flex flex-col gap-6">
          <div className="rounded-xl border border-orange-900/10 bg-white p-4">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="font-masthead flex items-center gap-1.5 text-base font-bold text-stone-900">
                <i className="ri-bard-line text-red-700"></i>
                编辑部精选
              </h3>
              <span className="text-xs text-stone-400">持续追踪中</span>
            </div>
            <ul className="divide-y divide-orange-900/10">
              {picks.map((p, i) => (
                <li key={p.id}>
                  <a href="#news" className="group flex gap-3 py-3 first:pt-0">
                    <span className="font-masthead text-xl font-black leading-none text-stone-300">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0">
                      <p className="line-clamp-2 text-sm leading-snug text-stone-700 group-hover:text-red-700">
                        {p.title}
                      </p>
                      <p className="mt-1 text-xs text-stone-400">{p.time}</p>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-xl border border-orange-900/10 bg-amber-50/60 p-4">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="font-masthead flex items-center gap-1.5 text-base font-bold text-stone-900">
                <i className="ri-flag-fill text-red-700"></i>
                今日热议 Top 3
              </h3>
              <a href="#trend" className="text-xs text-red-700 hover:text-red-800">
                查看完整榜单 →
              </a>
            </div>
            <ol className="space-y-3">
              {hotRankList.slice(0, 3).map((h) => (
                <li key={h.rank} className="flex items-start gap-3">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold text-white ${
                      h.rank === 1 ? "bg-red-700" : h.rank === 2 ? "bg-orange-500" : "bg-amber-500"
                    }`}
                  >
                    {h.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <a href="#news" className="line-clamp-2 text-sm leading-snug text-stone-800 hover:text-red-700">
                      {h.title}
                    </a>
                    <p className="mt-1 text-xs text-stone-400">
                      {h.heat} 热度 · {h.delta}
                    </p>
                  </div>
                  <i className={`mt-0.5 text-sm ${h.trend === "up" ? "text-red-600 ri-arrow-up-line" : h.trend === "down" ? "text-stone-400 ri-arrow-down-line" : "text-stone-400 ri-subtract-line"}`}></i>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>

      {/* 事件状态速览条 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-3 sm:grid-cols-3">
          <div className="flex items-center gap-3 rounded-xl border border-red-700/20 bg-red-700 px-4 py-3 text-white">
            <i className="ri-loop-left-line text-xl"></i>
            <div>
              <p className="text-sm font-semibold">2 起事件正处于反转关键期</p>
              <p className="text-xs text-white/80">证据与声明激烈交锋中</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-xl border border-orange-900/10 bg-white px-4 py-3">
            <i className="ri-verified-badge-line text-xl text-amber-600"></i>
            <div>
              <p className="text-sm font-semibold text-stone-800">3 起事件当事人已回应</p>
              <p className="text-xs text-stone-400">最新回应均已收录汇总</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-xl border border-orange-900/10 bg-white px-4 py-3">
            <i className="ri-check-double-line text-xl text-emerald-600"></i>
            <div>
              <p className="text-sm font-semibold text-stone-800">1 起事件已告一段落</p>
              <p className="text-xs text-stone-400">完整脉络已整理上线</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}